import { createFileRoute, Link } from "@tanstack/react-router"
import { IconArrowLeftFill18 } from "nucleo-ui-fill-18"

import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { CreateOrganisationForm } from "@/features/admin/components/create-organisation-form"

export const Route = createFileRoute(
  "/_authenticated/admin/organisations/create/"
)({
  component: CreateOrganisationPage,
})

function CreateOrganisationPage() {
  return (
    <>
      <PageHeader
        title="New organisation"
        actions={
          <Button
            variant="outline"
            nativeButton={false}
            render={
              <Link to="/admin/organisations">
                <IconArrowLeftFill18 data-icon="inline-start" />
                Organisations
              </Link>
            }
          />
        }
      />
      <div className="max-w-lg">
        <CreateOrganisationForm />
      </div>
    </>
  )
}
